import { memo } from 'react'

import TopicRefinementSection, { TEST_ID } from './TopicRefinementSection'

const TopicRefinementSectionComponent = memo(TopicRefinementSection)

export { TEST_ID }

export default TopicRefinementSectionComponent
